import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/styles/AboutUsMission.css";

const AboutUsMission = () => {
  return (
    <Container fluid className="mission-container">
      <Row className="align-items-center">
        <Col md={6} className="text-section">
          <h2 className="mission-title">Our Mission</h2>
          <p className="mission-text">
            As a leading contributor to driving change, we understand the
            importance of continued self-reinvention. We accomplish this by
            investing in next-generation capabilities that enhance our
            differentiation in key growth areas and by investing in talent to
            ensure we have specialized skills to resolve business problems.
            Backed by our expertise and diverse global workforce, our ultimate
            goal is to offer sustainable and meaningful value across all
            directions.
          </p>
        </Col>
        <Col md={6} className="image-section">
          <img src='/assets/mission.avif' alt="Mission" className="mission-image" />
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUsMission;
